import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import './index.css';

const loader = document.getElementById('initial-loader');
if (loader) {
  setTimeout(() => {
    loader.classList.add('loaded');
    setTimeout(() => loader.remove(), 500);
  }, 100);
}

const rootEl = document.getElementById('root')!;
const app = (
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);

// react-snap replaces #root content entirely; the raw HTML has #initial-loader inside #root.
// Hydrate only when actual pre-rendered React content is present (no initial-loader marker).
const isPreRendered = rootEl.hasChildNodes() && !rootEl.querySelector('#initial-loader');
if (isPreRendered) {
  hydrateRoot(rootEl, app);
} else {
  createRoot(rootEl).render(app);
}